import React from "react";
import { arrayHasAtLeastTwoItems } from "common/utils/arrays";
import { Button } from "../../../../Common/Button";
import { Icon } from "../../../../Common/Icons/LucideIcons";
import { SubmissionsBuilderButtonsWrapper } from "./__styles__/SubmissionsBuilder";

export const MenuRightButtons = ({
  isRightSideBarOpen,
  openRightSideBar,
  closeRightSideBar,
  versions,
  onSave,
  disabled,
  formIsDirty,
}: {
  isRightSideBarOpen: boolean;
  openRightSideBar: (selectedVersionId: string) => void;
  closeRightSideBar: () => void;
  versions: { id: string }[];
  onSave: () => void;
  disabled: boolean;
  formIsDirty: boolean;
}) => {
  const canOpenRightSideBar = arrayHasAtLeastTwoItems(versions) && !formIsDirty;

  return (
    <SubmissionsBuilderButtonsWrapper>
      {canOpenRightSideBar &&
        (isRightSideBarOpen ?
          <Button
            styleVariant="outlineLight"
            size="small"
            onClick={closeRightSideBar}
            disabled={formIsDirty}
          >
            Return to current version
          </Button>
        : <Icon
            iconName="history"
            color="contentSecondary"
            size={16}
            cursor="pointer"
            testId="version-history"
            onClick={() => openRightSideBar(versions[0].id)}
          />)}
      <Button
        styleVariant={"primary"}
        size="small"
        onClick={onSave}
        disabled={disabled}
      >
        Save
      </Button>
    </SubmissionsBuilderButtonsWrapper>
  );
};
